// Unpublished Work © 2025-2026 Deere & Company.

export const PRO_GOLF_LABOR_RESKIN = 'PRO_GOLF_LABOR_RESKIN';
export const PRO_GOLF_GROUP_SMS = 'PRO_GOLF_GROUP_SMS';
export const PRO_GOLF_PREVIEW_FIX = 'PRO_GOLF_PREVIEW_FIX';
export const PRO_GOLF_LICENSE_MANAGER = 'PRO_GOLF_LICENSE_MANAGER';
export const PRO_GOLF_LICENSE_MANAGER_2 = 'PRO_GOLF_LICENSE_MANAGER_2';
export const PRO_GOLF_PRESENTATION_REFRESH_FIX = 'PRO_GOLF_PRESENTATION_REFRESH_FIX';
export const GOLF_MOWING_DIRECTION_ROW = 'GOLF_MOWING_DIRECTION_ROW';
export const GOLF_FLEET_TO_EQUIPMENT = 'GOLF_FLEET_TO_EQUIPMENT';
export const MAINTENANCE_MANAGER_PROGOLF = 'MAINTENANCE_MANAGER_PROGOLF';
export const PRO_GOLF_NOVEMBER_2026_RELEASE = 'PRO_GOLF_NOVEMBER_2026_RELEASE';
export const PRO_GOLF_LABOR_REPORTS_1 = 'PRO_GOLF_LABOR_REPORTS_1';
